/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { TextItem, TextState } from './types';
import { MutationRequestError, MutationRequestStatus } from '../types';
import { MissingTranslation } from '../../types/missingTranslation';

export const mutations: MutationTree<TextState> = {
  textLoading(state) {
    state.news.error = undefined;
    state.news.status = MutationRequestStatus.LOADING;
  },
  textLoaded(state, payload: TextItem) {
    state.news.error = undefined;
    state.news.data = payload;
    state.news.status = MutationRequestStatus.SUCCESS;
  },
  textError(state, payload: MutationRequestError<MissingTranslation>) {
    state.news.error = payload;
    state.news.status = MutationRequestStatus.ERROR;
  },
};
